import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import LinkIconLight from 'assets/svg/app/link-light.svg'
import { Body } from 'components/Text'
import media from 'styles/media'

import useAbstractionInfo from '../hooks/useAbstractionInfo'

const AbstractionWalletInfo: FC = () => {
	const { t } = useTranslation()
	const { openWallet, truncatedAddress, balanceString, usedToken } = useAbstractionInfo()

	return (
		<InfoContainer>
			<InfoBlock>
				<InfoBlockTitle>{t('common.address')}:</InfoBlockTitle>
				<InfoBlockValue>
					{truncatedAddress}
					<LinkIconLight
						onClick={openWallet}
						height={14}
						width={14}
						style={{ cursor: 'pointer' }}
					/>
				</InfoBlockValue>
			</InfoBlock>
			<InfoBlock>
				<InfoBlockTitle>{t('futures.one-click-trading.onboard.balance')}:</InfoBlockTitle>
				<InfoBlockValue>
					{balanceString} {usedToken}
				</InfoBlockValue>
			</InfoBlock>
		</InfoContainer>
	)
}

const InfoBlock = styled.div`
	width: calc(50% - 15px);
	display: flex;
	flex-direction: column;
	gap: 5px;
`

const InfoBlockTitle = styled(Body)`
	color: ${(props) => props.theme.colors.selectedTheme.text.label};
`

const InfoBlockValue = styled(Body).attrs({ mono: true })`
	display: flex;
	align-items: center;
	gap: 5px;
	color: ${(props) => props.theme.colors.selectedTheme.text.value};
`

const InfoContainer = styled.div`
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 15px;
	align-items: center;
	padding: 15px;
	border: ${(props) => props.theme.colors.selectedTheme.border};
	border-radius: 4px;

	${media.lessThan('md')`
		padding: 10px;
	`}
`

export default AbstractionWalletInfo
